<template>
  <div class="c-app" :class="{ 'c-dark-theme': $store.state.darkMode }">
    <!-- <TheSidebar/> -->
    <TheAside/>
    <CWrapper>
      <!-- <TheHeader/> -->
      <div class="c-body">
        <!-- <main class="c-main"> -->
          <!-- <CContainer fluid> -->
            <transition name="fade">
              <router-view></router-view>
            </transition>
          <!-- </CContainer> -->
        <!-- </main> -->
        <!-- <TheFooter/> -->
      </div>
    </CWrapper>
    <SignIn/>
    <CenterLoading/>
    <DialogMessage/>

  </div>
</template>

<script>
import TheSidebar from './TheSidebar'
import TheHeader from './TheHeader'
import TheFooter from './TheFooter'
import TheAside from './TheAside'
import {mapGetters} from "vuex";
import store from "@/store/store";
//
import { io } from "socket.io-client";
import DialogMessage from "@/projects/components/dialog/DialogMessage.vue";
import CenterLoading from "@/projects/components/dialog/CenterLoading.vue";
import SignIn from "@/projects/components/dialog/SignIn.vue";
//
export default {
  name: 'TheContainer',
  components: {
    SignIn,
    CenterLoading,
    DialogMessage,
    TheSidebar,
    TheHeader,
    TheFooter,
    TheAside
  },

  mounted() {


  },

  methods: {

  },
  computed: {
    ...mapGetters({
    })
  },

  watch: {

  }

}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
